export default __webpack_public_path__ + "static/media/VestaboardWithNoCharacterUnits.d05c7074.png";